import React, { PropTypes, PureComponent } from 'react';
import { View, Switch, Alert, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import DismissableBar from './dismissable-bar';

class PaymentError extends PureComponent {
  deleteRecord = (obj, key) => {
    const errors = this.props.errors;
    errors.splice(key, 1);
    this.props.payments.setMsgs(errors);
    this.forceUpdate();
  }

  render() {
    const { errors } = this.props;
    return (
      <div className="pymtErr" id="text_paymentErrorSummary_index_test">
        {errors.map((val, i) =>
          <DismissableBar key={i} errors={errors} keyValue={i} error={val} deleteRecord={this.deleteRecord} />
        )}
      </div>
    );

  }

}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    payments: {
      setMsgs: { $set: 'errorMsgs' }
    }
  },
})(PaymentError);